export default __webpack_public_path__ + "static/media/aacorporation-home-icon.ab891e0c.png";